import React, { useEffect, useState } from 'react';
import { db } from '../../../../Config/firebase';
import { useAppSelector } from '../../../../state/state';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  
  Box,
  CircularProgress,
  
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import {
  collection,
  getDocs,
  orderBy,
  query,
  
} from 'firebase/firestore';

import { Download } from '@mui/icons-material';
import { selectEffectiveUID } from '../../../../state/UserStatesV2/userSliceV2';


interface Transaction {
  id: string;
  amount: number;
  timestamp: { seconds: number; nanoseconds: number };
  status: string;
  paymentId: string;

  receiptUrl:string|null

}

const TransactionHistory: React.FC = () => {
  const [transactions, setTransactions] = useState<Transaction[]>([]);
  const [loading, setLoading] = useState(true);
  const providerId =  useAppSelector(selectEffectiveUID);
  const navigate = useNavigate();

  useEffect(() => {
    if (providerId) {
      const fetchTransactions = async () => {
        setLoading(true);
        try {
          const payoutsRef = collection(
            db,
            'ServiceProviders',
            providerId,
            'Payouts'
          );
          const payoutsQuery = query(
            payoutsRef,
            orderBy('createdAt', 'desc')
          );
          const querySnapshot = await getDocs(payoutsQuery);

          const formattedTransactions: Transaction[] = [];

          querySnapshot.forEach((doc) => {
            const payoutData = doc.data();
            if (payoutData.transactions) {
              payoutData.transactions.forEach((transaction: any) => {
                formattedTransactions.push({
                  id: transaction.id.split('_')[0],
                  amount: transaction.amount,
                  timestamp: transaction.timestamp,
                  status: transaction.status,

                  paymentId: transaction.paymentId,
                  receiptUrl: transaction.status==="SUCCESS"?payoutData.receiptUrl:null


                });
              });
            }
          });
          formattedTransactions.sort((a, b) => b.timestamp.seconds - a.timestamp.seconds);
          setTransactions(formattedTransactions);
        } catch (error) {
          console.error('Error fetching transactions:', error);
        } finally {
          setLoading(false);
        }
      };

      fetchTransactions();
    }
  }, [providerId]);

  const handleBack = () => {
    navigate(-1);
  };
  const getPayoutId = (transactionId: string) => {
    return transactionId.split('|')[0];
  };

  const getRowStyle = (status: string) => {
    if (status.toLowerCase() === 'success') {
      return { backgroundColor: 'rgba(76, 175, 80, 0.1)' };
    } else if (status.toLowerCase() === 'failure' || status.toLowerCase() === 'failed') {
      return { backgroundColor: 'rgba(244, 67, 54, 0.1)' };
    }
    return {};
  };

  const getStatusStyle = (status: string) => {
    if (status.toLowerCase() === 'success') {
      return { color: '#4caf50', fontWeight: 'bold' };
    } else if (status.toLowerCase() === 'failure' || status.toLowerCase() === 'failed') {
      return { color: '#f44336', fontWeight: 'bold' };
    }
    return { fontWeight: 'bold' };
  };

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="200px"
      >
        <CircularProgress />
      </Box>
    );
  }

  return (

   <div className='p-4'> <Box>
      <div className='text-cc_link text-sm flex gap-1 cursor-pointer underline underline-offset-4' onClick={handleBack}>
        <ArrowBackIcon fontSize="small" />
        <span style={{ fontFamily: 'Arial, sans-serif', fontSize: '1rem' }}>Back to Profile</span>
      </div>
      <div className='my-4 mb-8'>
        <p className={"font-semibold text-2xl"} >Payment History</p>
        <p className='mt-1' >All the payments you have made will be displayed here.</p>
      </div>


      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>

              <TableCell style={{ fontFamily: 'Arial, sans-serif', fontWeight: '600' }}>DATE</TableCell>
              <TableCell style={{ fontFamily: 'Arial, sans-serif', fontWeight: '600' }}>AMOUNT</TableCell>
              <TableCell style={{ fontFamily: 'Arial, sans-serif', fontWeight: '600' }}>STATUS</TableCell>
              <TableCell style={{ fontFamily: 'Arial, sans-serif', fontWeight: '600' }}>PAYMENT ID</TableCell>
              <TableCell style={{ fontFamily: 'Arial, sans-serif', fontWeight: '600' }}>TRANSACTION ID</TableCell>
              <TableCell style={{ fontFamily: 'Arial, sans-serif', fontWeight: '600' }}> RECEIPT</TableCell>

            </TableRow>
          </TableHead>
          <TableBody>
            {transactions.map((transaction) => (
              <TableRow key={`${transaction.id}-${transaction.timestamp.seconds}`} style={getRowStyle(transaction.status)}>

                <TableCell style={{ fontFamily: 'Arial, sans-serif' }}>
                  {new Date(transaction.timestamp.seconds * 1000).toLocaleString()}
                </TableCell>
                <TableCell style={{ fontFamily: 'Arial, sans-serif' }}>₹{transaction.amount.toFixed(2)}</TableCell>
                <TableCell>
                  <span style={{ ...getStatusStyle(transaction.status), fontFamily: 'Arial, sans-serif' }}>
                    {transaction.status}
                  </span>
                </TableCell>
                <TableCell style={{ fontFamily: 'Arial, sans-serif' }}>{transaction.paymentId}</TableCell>
                <TableCell style={{ fontFamily: 'Arial, sans-serif' }}>{getPayoutId(transaction.id)}</TableCell>
                {transaction.receiptUrl?<TableCell><a target='_blank' className='underline underline-offset-2' href={transaction.receiptUrl} download style={{ color: 'blue',  cursor: 'pointer' }}><Download fontSize='small'/> Download</a></TableCell>:<TableCell/>}

              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

    </Box></div>
  );
};


export default TransactionHistory;

